<template>
    <div class="audienceInfoCon">
        <div class="pawCon">
            <h2>修改密码</h2>
            <div>
                <div></div>
                <div>
                    <ul>
                        <li>
                            <p>旧密码：</p>
                            <input type="password" placeholder="请输入旧密码" v-model="oldPawText" ref="oldPawInp">
                            <span>{{ oldPawTextErr }}</span>
                            <div></div>
                        </li>
                        <li>
                            <p>新密码：</p>
                            <input type="password" placeholder="请输入新密码" v-model="newPawText" ref="newPawInp" @focus="newPawInpFoucs">
                            <span>{{ newPawTextErr }}</span>
                            <div></div>
                        </li>
                        <li>
                            <p>确认密码：</p>
                            <input type="password" placeholder="请确认密码" v-model="confirmNewPawText" @focus="conformNewPawInpFoucs" ref="confirmNewPawText">
                            <span>{{ confirmNewPawTextErr }}</span>
                            <div></div>
                        </li>
                    </ul>
                    <div>
                        <div @click="updatePaw">确认</div>
                        <div @click="pawReset">取消</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { clearInterval } from 'timers';
export default {
    data() {
        return {
            // 密码
            oldPawText: null,
            oldPawTextErr: "",
            newPawText: null,
            newPawTextErr: "",
            confirmNewPawText: null,
            confirmNewPawTextErr: "",
        }
    },
    mounted() {
    },
    methods: {
        newPawInpFoucs() {
            let that = this;
            if( !that.oldPawText || that.oldPawText =="" ) {
                that.oldPawTextErr = "旧密码不能为空";
                that.$refs.oldPawInp.focus();
            }else{
                that.oldPawTextErr = "";
            }
        },
        conformNewPawInpFoucs() {
            let that = this;
            if( that.newPawText.length < 6 || that.newPawText.length > 20 ) {
                that.newPawTextErr = "新密码不能小于6位或大于20位";
                that.$refs.newPawInp.focus();
            }else{
                that.newPawTextErr = "";
            }
        },
        updatePaw() {
            let that = this;
            if( !that.oldPawText || that.oldPawText =="" ) {
                that.oldPawTextErr = "旧密码不能为空";
                that.$refs.oldPawInp.focus();
                return false;
            }else if( that.oldPawText === that.newPawText ){
                that.newPawTextErr = "新旧密码不能重复";
                that.$refs.newPawInp.focus();
                return false;
            }else if( !that.newPawText || that.newPawText.length < 6 || that.newPawText.length > 20 ) {
                that.newPawTextErr = "新密码不能小于6位或大于20位";
                that.$refs.newPawInp.focus();
                return false;
            }else if( that.confirmNewPawText !== that.newPawText ){
                that.confirmNewPawTextErr = "两次密码不一致";
                that.$refs.confirmNewPawText.focus();
                return false;
            }else{
                // let data = {
                //     now: that.$md5(that.confirmNewPawText),
                //     old: that.$md5(that.oldPawText)
                // }
                let data = new FormData();
                data.append("now", that.$md5(that.confirmNewPawText));
                data.append("old", that.$md5(that.oldPawText));
                that.allApi.changePwd(data).then((resource) => {
                    if( resource.data.code == 200 ) {
                        that.pawReset();
                    }else if( resource.data.code == 500 ) {
                        that.oldPawTextErr = "旧密码有误";
                        that.$refs.oldPawInp.focus();
                    }else if( resource.data.code == 401 ) {
                        that.$router.push({
                            path: "/"
                        });
                    }
                })
            }
        },
        pawReset() {
            let that = this;
            that.oldPawText = null;
            that.oldPawTextErr = "";
            that.newPawText = null;
            that.newPawTextErr = "";
            that.confirmNewPawText = null;
            that.confirmNewPawTextErr = "";
        }
    },
    watch: {
    }
}
</script>
<style lang="scss" scoped>
    .audienceInfoCon{
        >div{
            margin: 0 25px;
            border-bottom: 1px solid #ccc;
            margin-bottom: 18px;
            >h2{
                color: #000;
                font-size: 26px;
                font-weight: 500;
                margin-bottom: 38px;
            }
            >div{
                >div:first-child{
                    display: flex;
                    justify-content: center;
                    line-height: 40px;
                    margin-bottom: 30px;
                    >p{
                        color: #666;
                        font-size: 24px;
                        margin-right: 20px;
                    }
                    >span{
                        color: #09A4D8;
                        font-size: 20px;
                        display: block;
                        cursor: pointer;
                    }
                }
                >div:last-child{
                    >ul{
                        width: 560px;
                        margin: 0 auto 48px;
                        >li{
                            overflow: hidden;
                            padding-bottom: 45px;
                            position: relative;
                            >p{
                                width: 120px;
                                line-height: 42px;
                                float: left;
                                font-size: 24px;
                                color: #333;
                                text-align: right;
                                margin-right: 20px;
                                height: 42px;
                            }
                            >input{
                                float: left;
                                width: 280px;
                                height: 42px;
                                border: 1px solid #999999;
                                padding: 0 10px;
                                @include secondary_color(#999);
                                margin-right: 15px;
                                outline: none;
                                font-size: 18px;
                                line-height: 40px;
                                border-radius: 4px;
                            }
                            >div{
                                font-size: 20px;
                                color: #09A4D8;
                                float: left;
                                line-height: 42px;
                                cursor: pointer;
                            }
                            >span{
                                position: absolute;
                                left: 140px;
                                top: 52px;
                                font-size: 18px;
                                color: #FE0000;
                            }
                        }
                    }
                    >div{
                        width: 540px;
                        margin: 0 auto 30px;
                        overflow: hidden;
                        padding-left: 150px;
                        >div{
                            float: left;
                            margin-right: 86px;
                            background:linear-gradient(0deg,rgba(26,167,224,1) 0%,rgba(56,189,255,1) 48%,rgba(26,167,224,1) 100%);
                            height: 40px;
                            border-radius: 10px;
                            width: 86px;
                            color: #fff;
                            text-align: center;
                            line-height: 40px;
                            font-size: 18px;
                            cursor: pointer;
                            &:last-child{
                                background: #999999;
                            }
                        }
                    }
                }
            }
            // &.cardCon{
            //     >div{
            //         >div:last-child{
            //             >ul{
            //                 >li:nth-child(2){
            //                     padding-bottom: 0;
            //                     >div{
            //                         width: 280px;
            //                         color: #333333;
            //                         float: none;
            //                         line-height: 42px;
            //                         overflow: hidden;
            //                         margin-left: 140px;
            //                         >div{
            //                             float: left;
            //                             width: 20px;
            //                             height: 20px;
            //                             margin-right: 14px;
            //                             margin-top: 11px;
            //                             background: #000;
            //                         }
            //                         >input{
            //                             display: none;
            //                         }
            //                         >p{
            //                             float: left;
            //                             font-size: 18px;
            //                             color: #333333;
            //                         }
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // }
        }
        
    }
</style>